"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexCodeToStyleVariants = void 0;
const stylevariants_to_hexcode_1 = require("./stylevariants-to-hexcode");
exports.HexCodeToStyleVariants = Object.fromEntries(Object.entries(stylevariants_to_hexcode_1.StyleVariantsToHexCode).map(([key, value]) => [value, key]));
